(() => {
  function initCarousel(section) {
    const viewport = section.querySelector('[data-hc-carousel]');
    const track = section.querySelector('[data-hc-track]');
    if (!viewport || !track) return;

    const state = {
      raf: 0,
      auto: 0,
      drag: 0,
      dragStart: 0,
      dragging: false,
      paused: false,
      lastT: 0,
      velocity: 0,
      inertia: 0,
      cycleW: 0,
      lastDragX: 0,
      lastDragT: 0,
    };

    const AUTO_PX_PER_MS = 0.04;

    function measure() {
      // cycleW = width of one full pass (total / 4 loops)
      state.cycleW = track.scrollWidth / 4;
    }
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(track);

    function tick(t) {
      if (!state.lastT) state.lastT = t;
      const dt = t - state.lastT;
      state.lastT = t;

      if (!state.dragging && !state.paused) {
        state.auto -= AUTO_PX_PER_MS * dt;
        state.inertia += state.velocity * dt;
        state.velocity *= Math.pow(0.92, dt / 16);
        if (Math.abs(state.velocity) < 0.001) state.velocity = 0;
      }

      const cw = state.cycleW || 1;
      if (state.auto < -cw) state.auto += cw;
      if (state.auto > 0) state.auto -= cw;
      if (state.inertia < -cw) state.inertia += cw;
      if (state.inertia > cw) state.inertia -= cw;

      const total = state.auto + state.drag + state.inertia;
      track.style.transform = `translate3d(${total - cw}px, 0, 0)`;
      state.raf = requestAnimationFrame(tick);
    }
    state.raf = requestAnimationFrame(tick);

    function getX(e) {
      return e.clientX ?? e.touches?.[0]?.clientX ?? 0;
    }

    function onDown(e) {
      const x = getX(e);
      state.dragging = true;
      state.dragStart = x;
      state.drag = 0;
      state.velocity = 0;
      state.lastDragX = x;
      state.lastDragT = performance.now();
      if (e.cancelable) e.preventDefault();
    }

    function onMove(e) {
      if (!state.dragging) return;
      const x = getX(e);
      state.drag = x - state.dragStart;
      const now = performance.now();
      const dt = Math.max(1, now - state.lastDragT);
      state.velocity = (x - state.lastDragX) / dt;
      state.lastDragX = x;
      state.lastDragT = now;
    }

    function onUp() {
      if (!state.dragging) return;
      state.auto += state.drag;
      state.drag = 0;
      state.dragging = false;
    }

    viewport.addEventListener('mouseenter', () => { state.paused = true; });
    viewport.addEventListener('mouseleave', (e) => { state.paused = false; onUp(e); });
    viewport.addEventListener('mousedown', onDown);
    viewport.addEventListener('mousemove', onMove);
    viewport.addEventListener('mouseup', onUp);
    viewport.addEventListener('touchstart', onDown, { passive: false });
    viewport.addEventListener('touchmove', onMove, { passive: true });
    viewport.addEventListener('touchend', onUp);

    // Shopify theme editor live reload
    section.addEventListener('shopify:section:unload', () => {
      cancelAnimationFrame(state.raf);
      ro.disconnect();
    });
  }

  document.querySelectorAll('.hc-hero-carousel').forEach(initCarousel);

  // Support Shopify theme editor re-renders
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.hc-hero-carousel');
    if (section) initCarousel(section);
  });
})();
